import { render } from "./trial.vue?vue&type=template&id=5da692ca&lang=pug"
import script from "./trial.vue?vue&type=script&lang=js"
export * from "./trial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__